import '../css/calendar.css';

const calendarFrame = document.querySelector('#calendar-frame');
if (calendarFrame) {
	import(
		/* webpackChunkName: 'iframeResizer' */ 'iframe-resizer/js/iframeResizer.js'
	).then(({ default: iframeResizer }) => {
		iframeResizer(
			{
				heightCalculationMethod: 'taggedElement',
			},
			calendarFrame
		);
	});

	let params = new URLSearchParams(window.location.search.slice(1));
	let calendarName = params.get('calendarName');
	let calendarView = params.get('calendarView');
	let calendarDate = params.get('calendarDate');
	let calendarEvent = params.get('calendarEvent');
	let showLocations = params.get('showLocations');
	let showCalendarNames = params.get('showCalendarNames');
	let customCalendars = params.getAll('customCalendar');

	let calendarParams = new URLSearchParams();
	calendarParams.append('key', 'intranet');

	if (calendarView) calendarParams.set('view', calendarView);
	if (calendarDate) calendarParams.set('date', calendarDate);
	if (showLocations) calendarParams.set('showLocations', 'true');
	if (showCalendarNames) calendarParams.set('showCalendarNames', 'true');
	if (customCalendars && customCalendars.length > 0) {
		for (let calId of customCalendars) {
			calendarParams.append('customCalendar', calId);
		}
	}

	let calendarBaseUrl = 'https://calendar.mcw-anesthesiology.tech';
	let calendarPath = calendarName ? '/' + calendarName : '';
	let calendarHash = calendarEvent ? '#' + calendarEvent : '';

	calendarFrame.src =
		calendarBaseUrl +
		calendarPath +
		calendarHash +
		'?' +
		calendarParams.toString();

	window.addEventListener('message', (event) => {
		if (
			event.origin === calendarBaseUrl &&
			event.data &&
			event.data.action === 'calendarStateResponse'
		) {
			let newParams = new URLSearchParams();

			if (event.data.calendarName)
				newParams.set('calendarName', event.data.calendarName);
			if (event.data.calendarEvent)
				newParams.set('calendarEvent', event.data.calendarEvent);
			if (event.data.calendarView)
				newParams.set('calendarView', event.data.calendarView);
			if (event.data.calendarDate)
				newParams.set('calendarDate', event.data.calendarDate);
			if (event.data.showLocations)
				newParams.set('showLocations', 'true');
			if (event.data.showCalendarNames)
				newParams.set('showCalendarNames', 'true');
			if (
				event.data.customCalendars &&
				event.data.customCalendars.length > 0
			) {
				for (let calId of event.data.customCalendars) {
					newParams.append('customCalendar', calId);
				}
			}

			let url =
				window.location.origin +
				window.location.pathname +
				'?' +
				newParams.toString();

			let content = document.querySelector('#calendar-link-content');
			if (content) {
				content.value = url;
				content.style.display = 'inline';
			}
		}
	});

	let button = document.querySelector('#calendar-link-button');
	if (button)
		button.addEventListener('click', () => {
			calendarFrame.contentWindow.postMessage(
				'getCalendarState',
				calendarBaseUrl
			);
		});
}
